import { render, staticRenderFns } from "./Usehis.vue?vue&type=template&id=30220766&scoped=true"
import script from "./Usehis.vue?vue&type=script&lang=js"
export * from "./Usehis.vue?vue&type=script&lang=js"
import style0 from "./Usehis.vue?vue&type=style&index=0&id=30220766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30220766",
  null
  
)

export default component.exports